// extracted by mini-css-extract-plugin
export default {"container":"P_container__h9Naj"};